import React, {useState} from "react";
import {Modal} from "flowbite-react";
import DefaultButton from "../buttons/DefaultButton";

interface ConfirmButtonProps {
  content?: React.ReactNode;
  confirmText?: string;
  onConfirm: (e?: React.MouseEvent) => void;
  onClick?: (e?: React.MouseEvent) => void;
  disabled?: boolean;
  className?: string;
}

function ConfirmButton({
  content = "Bevestigen",
  confirmText = "Weet je het zeker?",
  onConfirm,
  onClick,
  disabled = false,
  className = "",
}: ConfirmButtonProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e?.stopPropagation?.();
    onClick?.(e);
    setOpenModal(true);
  };

  const handleConfirm = (e: React.MouseEvent) => {
    setOpenModal(false);
    onConfirm?.(e);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <DefaultButton
        content={content}
        onClick={handleClick}
        disabled={disabled}
        className={className}
      />
      <Modal show={openModal} onClose={handleClose}>
        <Modal.Header>Bevestigen</Modal.Header>
        <Modal.Body>
          <p className="text-base leading-relaxed text-red-500">
            {confirmText}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <DefaultButton onClick={handleConfirm} content="JA" />
          <DefaultButton onClick={handleClose} content="NEE" />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmButton;
